<template>
    <PopUpDialog
        :show="true"
        :hasButtons="false"
        :closeable="false"
        :isBlured="true">
        <template #bodyContainer>
            <div
                id="dialog"
                class="flex w-full flex-col border-[#65686E] bg-[#141414] bg-transparent py-8 px-10">
                <div class="flex flex-col items-center justify-center text-center">
                    <img
                        src="https://sm.naughtycdn.com/images/www/naughty-america-logo.png"
                        class="max-w-[300px] mb-6"
                        alt="NA Logo" />

                    <h1 class="mx-auto mb-4 flex w-auto text-center text-[19px] md:text-[25px] font-semibold text-[#fff]">
                        This video isn't safe for work
                    </h1>

                    <p class="text-[#AFAFAF] text-[16px] md:text-[18px] leading-relaxed mb-8">
                        You're browsing from a region where explicit previews are restricted.
                        Sign up now to unlock the full video.
                    </p>

                    <button
                        type="button"
                        @click.prevent="goToJoinPage"
                        class="w-full max-w-[300px] bg-red-600 hover:bg-red-700 active:bg-red-800 text-white px-6 py-3.5 rounded-xl text-sm font-semibold uppercase tracking-widest transition-all shadow-lg focus:outline-none focus:ring-0 focus:ring-offset-0">
                        Sign Up Now
                    </button>
                </div>
            </div>
        </template>
    </PopUpDialog>
</template>
<style scoped>
#dialog {
    border: 1px solid #444;
    border-radius: 6px;
    background-color: #101010;
    color: #999;
}
</style>
<script setup>
import PopUpDialog from '@/Components/Common/PopUpDialog.vue'

// No close/exit affordance on purpose: the gate is the only thing a guest in an SFW
// region may act on, and it deliberately offers no way through to the explicit feed.
const goToJoinPage = () => {
    window.location.href = route('www.join.signUp', { custom6: 'clipsSfwGate' })
}
</script>
